import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import withStyles from 'isomorphic-style-loader/withStyles';
import classNames from 'classnames';
import { options } from 'config/reactRedux';
import { getEdition } from 'selectors/getEdition';
import getIsArticlePage from 'selectors/getIsArticlePage';
import getLearnLanguage from 'selectors/getLearnLanguage';
import { learnLanguageToTag } from 'utils/tagToLearnLanguage';
import I18n from 'components/i18n';
import Link from 'components/link';
import { LANGUAGES } from 'config/types/prop';
import icons from 'config/icons';
import discoverDeeplinkUrl from 'utils/discoverDeeplinkUrl';
import getLocale from 'selectors/getLocale';
import Logo from './Logo';
import styles from './inProductHeader.css';

const InProductHeader = ({ currentEdition, history, isArticlePage, learnLanguage, locale }) => (
  <div>
    <nav className={classNames(styles.navBar, { [styles.navBarArticle]: isArticlePage })}>
      <Logo currentEdition={currentEdition} className={styles.logoDesktop} />
      <Link
        className={classNames(styles.backButton, { [styles.backButtonArticle]: isArticlePage })}
        to={
          isArticlePage ?
            `/${currentEdition}/magazine/tags/${learnLanguageToTag(currentEdition, learnLanguage)}` :
            discoverDeeplinkUrl(learnLanguage, locale)
        }
      >
        <span className={classNames(styles.backButtonDesktopContent)}>
          <I18n
            field={isArticlePage ? 'in-app-article-close' : 'in-app-back-button-desktop'}
            defaultText={isArticlePage ? 'Close' : 'Back to explore'}
          />
        </span>
        <span className={classNames(styles.backButtonMobileContent)}>
          {isArticlePage ?
            <img
              alt="Close"
              src={icons.xThinSpaceGrey}
              height="32"
              width="32"
              /*
                Added key here and below otherwise React reuses previous icon for the next render
                leading to a flicker of the wrong icon.
              */
              key="close-icon"
            /> :
            <>
              <img
                alt="Back arrow"
                src={icons.leftArrowSimple}
                height="20"
                width="20"
                className={styles.backArrow}
                key="back-icon"
              />
              <I18n
                field={'in-app-back-button-mobile'}
                defaultText={'Explore'}
              />
            </>
          }
        </span>
      </Link>
    </nav>
    {!isArticlePage && <Logo currentEdition={currentEdition} className={styles.logoMobile} />}
  </div>
);

InProductHeader.propTypes = {
  currentEdition: LANGUAGES.isRequired,
  isArticlePage: PropTypes.bool.isRequired,
  history: PropTypes.object.isRequired,
  learnLanguage: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  currentEdition: getEdition(state),
  isArticlePage: getIsArticlePage(state),
  learnLanguage: getLearnLanguage(state),
  locale: getLocale(state),
});

const withRedux = connect(
  mapStateToProps,
  undefined,
  undefined,
  options,
);

const wrapWithStyles = withStyles(styles);

export default withRouter(wrapWithStyles(withRedux(InProductHeader)));
